import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { ghgCategoryField } from './common/sharedFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import { purchasedMaterialFields } from './common/productFields';
import { msg } from '@lingui/core/macro';

export const activityWithCustomEfMetadata = {
  displayName: msg({
    message: 'Custom activity with custom emissions factors',
    context: 'Activity data schema name',
  }),
  fields: {
    ...coreFields,
    ...vendorFields,
    ...productFields,
    ...purchasedMaterialFields,
    ghg_category_id: ghgCategoryField,
    emissions_specifier: {
      displayName: msg({
        message: 'Emissions specifier',
        context: 'The display name for a dimension',
      }),
    },
    quantity: {
      displayName: msg({
        message: 'Custom quantity',
        context: 'The display name for a metric',
      }),
      externalDescription: msg({
        message: 'The quantity of the emissive activity.',
        context: 'Quantity',
      }),
    },
    unit: {
      displayName: msg({
        message: 'Raw custom unit',
        context:
          'The unit associated with the quantity field where the quantity can represent any unit type (i.e. volume, mass, etc).',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
